import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Listen for `{type: "navigate", url}` messages the SW dispatches when the
 * user taps a push notification. Also honours the OS deep-link path so
 * PWA shortcuts (Panel / Görevler / Takvim / Motivasyon) work correctly.
 */
export function useServiceWorkerNavigation() {
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof navigator === "undefined" || !navigator.serviceWorker) return;
    const onMessage = (event) => {
      const data = event.data;
      if (data && data.type === "navigate" && typeof data.url === "string") {
        // Strip origin if present so react-router can resolve the path.
        try {
          const u = new URL(data.url, window.location.origin);
          navigate(u.pathname + u.search + u.hash);
        } catch {
          navigate(data.url);
        }
      }
    };
    navigator.serviceWorker.addEventListener("message", onMessage);
    return () => navigator.serviceWorker.removeEventListener("message", onMessage);
  }, [navigate]);
}
